import * as React from 'react';
// import styles from './index.less';
import './index.less';
import { Tooltip } from 'antd';
import { CSSProperties } from 'react';
import * as AHooks from 'ahooks';
import { FUtil } from '@freelog/tools-lib';
import { TooltipPlacement } from 'antd/lib/tooltip';

const HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY = 'HotspotTooltip';

type ContentKey =
  'header.gotoConsoleBtn'
  | 'header.discoverNav'
  // | 'createResourcePage.createBtn' //
  // | 'createResourceVersionPage.createBtn'
  // | 'createResourceVersionPage.uploadFileBtn'
  | 'policyBuilder.resource.policyTemplateBtn'
  | 'policyBuilder.resource.policyVerifyBtn'
  | 'policyBuilder.resource.policyCreateBtn'
  | 'policyBuilder.exhibit.policyTemplateBtn'
  | 'policyBuilder.exhibit.policyVerifyBtn'
  | 'policyBuilder.exhibit.policyCreateBtn'
  | 'createNodePage.createBtn'
  | 'resourceDetailPage.nodeSelector'
  | 'resourceDetailPage.checkPolicy'
  // | 'nodeManager.nodeLink'
  | 'exhibitDetailPage.onlineSwitch'
  | 'exhibitDetailPage.createFirstPolicy'
  | 'resourceVersionEditorPage.noVersionAndCreateVersion'

  // 0.16.1.1
  | 'resourceCreator.step1.createButton'
  | 'resourceCreator.step2.submitButton'
  | 'resourceCreator.step4.onlineButton'
  // | 'resourceCreator.result.success'
  | 'result.createResourceSuccess.manageMyResourceButton'
  | 'result.createResourceSuccess.contractToNodeDrawer.confirmButton'

  | 'batchResourceCreator.selectResourceType.submitButton'
  | 'batchResourceCreator.perfectInformation.submitButton'
  | 'batchResourceCreator.perfectInformation.applyLabelButton'
  | 'batchResourceCreator.perfectInformation.applyPolicyButton'

  | 'collectionCreator.step1.createButton'
  | 'collectionCreator.step2.addResourceButton'
  | 'collectionCreator.addResourceDrawer.confirmButton'
  | 'collectionCreator.addResourceDrawer.createResourceButton'
  | 'collectionCreator.step2.submitButton'
  | 'collectionCreator.step4.submitButton'

  | 'myResourceList.batchManagementButton'
  | 'myCollectionList.batchManagementButton'
  ;

type ContentValue = 'show' | 'hide';

type HotspotTooltip_LocalStorage_Content = {
  [k in ContentKey]?: ContentValue;
};

const defaultContent: HotspotTooltip_LocalStorage_Content = {
  'header.gotoConsoleBtn': 'show',
  'header.discoverNav': 'hide',
  // 'createResourcePage.createBtn': 'hide',
  // 'createResourceVersionPage.createBtn': 'hide',
  // 'createResourceVersionPage.uploadFileBtn': 'show',
  'policyBuilder.resource.policyTemplateBtn': 'show',
  'policyBuilder.resource.policyVerifyBtn': 'hide',
  'policyBuilder.resource.policyCreateBtn': 'show',
  'createNodePage.createBtn': 'hide',
  'resourceDetailPage.nodeSelector': 'show',
  'resourceDetailPage.checkPolicy': 'show',
  'policyBuilder.exhibit.policyTemplateBtn': 'show',
  'policyBuilder.exhibit.policyVerifyBtn': 'hide',
  'policyBuilder.exhibit.policyCreateBtn': 'show',
  // 'nodeManager.nodeLink': 'show',
  'exhibitDetailPage.onlineSwitch': 'hide',
  'exhibitDetailPage.createFirstPolicy': 'show',
  'resourceVersionEditorPage.noVersionAndCreateVersion': 'show',

  // 0.16.1.1
  'resourceCreator.step1.createButton': 'hide',
  'resourceCreator.step2.submitButton': 'hide',
  'resourceCreator.step4.onlineButton': 'show',
  // 'resourceCreator.result.success': 'show',
  'result.createResourceSuccess.manageMyResourceButton': 'show',
  'result.createResourceSuccess.contractToNodeDrawer.confirmButton': 'hide',

  'batchResourceCreator.selectResourceType.submitButton': 'hide',
  'batchResourceCreator.perfectInformation.submitButton': 'hide',
  'batchResourceCreator.perfectInformation.applyLabelButton': 'show',
  'batchResourceCreator.perfectInformation.applyPolicyButton': 'show',

  'collectionCreator.step1.createButton': 'hide',
  'collectionCreator.step2.addResourceButton': 'show',
  'collectionCreator.addResourceDrawer.confirmButton': 'hide',
  'collectionCreator.addResourceDrawer.createResourceButton': 'show',
  'collectionCreator.step2.submitButton': 'show',
  'collectionCreator.step4.submitButton': 'show',

  'myResourceList.batchManagementButton': 'show',
  'myCollectionList.batchManagementButton': 'show',
};

function getHotspotTooltip_LocalStorage_Content(key: ContentKey): ContentValue | undefined {
  const contentString: string = self.localStorage.getItem(HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY) || '{}';
  const content: HotspotTooltip_LocalStorage_Content = JSON.parse(contentString);
  return content[key];
}

function setHotspotTooltip_LocalStorage_Content(key: ContentKey, value: ContentValue) {
  const contentString: string = self.localStorage.getItem(HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY) || '{}';
  const content: HotspotTooltip_LocalStorage_Content = JSON.parse(contentString);
  const newContentString: string = JSON.stringify({
    ...content,
    [key]: value,
  });
  self.localStorage.setItem(HOTSPOT_TOOLTIP_LOCALSTORAGE_KEY, newContentString);
}

interface FHotspotTooltipProps {
  id: ContentKey;
  children: React.ReactNode;
  text: React.ReactNode;
  style?: CSSProperties;
  zIndex?: number;
  placement?: TooltipPlacement;

  onMount?(): void;

  onOpenChange?(o: boolean): void;
}

const set_visible_funcs: {
  [k in ContentKey]?: (value: boolean) => void;
} = {};

function FHotspotTooltip({
                           id,
                           children,
                           style = {},
                           text,
                           onMount,
                           zIndex = 10000,
                           onOpenChange,
                           placement = 'bottomRight',
                         }: FHotspotTooltipProps) {

  const ref = React.useRef<any>();

  const [$open, set$open, get$open] = FUtil.Hook.useGetState<boolean>((getHotspotTooltip_LocalStorage_Content(id) || defaultContent[id]) === 'show');

  AHooks.useMount(() => {
    set_visible_funcs[id] = set$open;
    onMount && onMount();
  });

  AHooks.useDebounceEffect(() => {
    onOpenChange?.(get$open());
  }, [$open], {
    wait: 30,
  });

  if (!$open) {
    return <>{children}</>;
  }

  return (<div
    ref={ref}
    style={{ width: 'fit-content', height: 'fit-content', position: 'relative' }}>
    {children}
    <Tooltip
      open={$open}
      // placement='bottomRight'
      placement={placement}
      title={text}
      color='#FFFFFF linear-gradient(135deg, #4568DC 0%, #B06AB3 100%)'
      overlayInnerStyle={{
        padding: '12px 20px',
        borderRadius: 8,
      }}
      getPopupContainer={() => ref.current}
      zIndex={zIndex}
    >
      <div
        className={'FHotspotTooltip'}
        style={{
          ...style,
          zIndex: zIndex,
        }}>
        <div className={'outerRing'}>
          <div className={'innerCircle'} />
        </div>
      </div>
    </Tooltip>
  </div>);
}

export default FHotspotTooltip;

// fSetHotspotTooltipVisible
export function fSetHotspotTooltipVisible(id: ContentKey, option: {
  value: boolean;
  effectiveImmediately: boolean;
  onlyNullish: boolean;
}) {
  if (option.onlyNullish && getHotspotTooltip_LocalStorage_Content(id) !== undefined) {
    return;
  }
  if (option.effectiveImmediately) {
    const func = set_visible_funcs[id];
    func && func(option.value);
  }

  setHotspotTooltip_LocalStorage_Content(id, option.value ? 'show' : 'hide');
}
